import React, { isValidElement } from "react";
import { toast } from "react-toastify";
import { Check, X } from "lucide-react";
import "react-toastify/dist/ReactToastify.css";
import "./toast.css";

const Bang = () => <span className="nx-toast__icon-bang">!</span>;
const Tick = () => <Check size={19} strokeWidth={3} />;
const Cross = () => <X size={19} strokeWidth={3} />;

const VARIANTS = {
  error: { Icon: Cross, autoClose: 4000 },
  success: { Icon: Tick, autoClose: 3000 },
  warning: { Icon: Bang, autoClose: 4000 },
};

// Callers pass strings, JSX, or occasionally undefined/objects from API
// responses — anything that can't be rendered falls back to the default.
const renderable = (message, fallback) =>
  typeof message === "string" ||
  typeof message === "number" ||
  isValidElement(message)
    ? message
    : fallback;

const CloseButton = ({ closeToast }) => (
  <button
    type="button"
    className="nx-toast__close"
    onClick={closeToast}
    aria-label="Close notification"
  >
    <X size={16} strokeWidth={2.25} />
  </button>
);

export const showToast = (variant, message, fallback, options) => {
  const { Icon, autoClose } = VARIANTS[variant];

  // The actual message is the headline — colour and icon already tell the
  // user whether it's an error, success or warning.
  toast(
    <div className="nx-toast__message">{renderable(message, fallback)}</div>,
    {
      type: variant,
      // A repeat of the same toast while it still shows is ignored. Without an
      // explicit options.toastId, identical text messages share an id so
      // double-firing callers don't stack duplicates. Only toastId is read
      // from options — some callers pass an Error here.
      toastId:
        options?.toastId ??
        (typeof message === "string" ? `${variant}:${message}` : undefined),
      position: "top-center",
      autoClose,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      theme: "light",
      icon: (
        <span className={`nx-toast__icon nx-toast__icon--${variant}`}>
          <Icon />
        </span>
      ),
      closeButton: CloseButton,
      className: `nx-toast nx-toast--${variant}`,
      bodyClassName: "nx-toast__body",
      progressClassName: "nx-toast__progress",
    }
  );
};
